var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconMd = function SvgIconMd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M17.218 1.191A11.95 11.95 0 0 0 12 .001c-1.87 0-3.64.427-5.217 1.19l-1.044 10.81L6.783 22.81A11.95 11.95 0 0 0 12 24c1.87 0 3.64-.427 5.218-1.19L18.26 12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M6.783 1.192A12 12 0 0 0 0 12.001 12 12 0 0 0 6.783 22.81z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M17.218 1.192V22.81A12 12 0 0 0 24 12a12 12 0 0 0-6.782-10.809"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9811",
    d: "M16.174 9.442h-2.87a1.304 1.304 0 0 0-2.608 0h-2.87c0 .71.618 1.284 1.327 1.284H9.11c0 .71.575 1.285 1.285 1.285 0 .628.45 1.15 1.047 1.261l-1.013 2.285a4.16 4.16 0 0 0 3.142 0l-1.012-2.285a1.284 1.284 0 0 0 1.046-1.261c.71 0 1.285-.575 1.285-1.284h-.043c.71 0 1.327-.575 1.327-1.285"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M12 11.218 10.305 12v1.566L12 14.609l1.696-1.043V12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M13.696 10.434h-3.391V12h3.391z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconMd;